import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cust-homeowner",
  "use": "cust-homeowner-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"cust-homeowner\"><path d=\"M17.34 17.87H2.66V9.71a.52.52 0 0 1 .52-.53.53.53 0 0 1 .53.53v7.11h12.58V9.71a.53.53 0 0 1 .53-.53.52.52 0 0 1 .52.53Z\" class=\"cls-1\" /><path d=\"M19.91 9.48a.5.5 0 0 1-.44.24.5.5 0 0 1-.28-.08L10 3.66 4.71 7.08.82 9.64a.53.53 0 0 1-.59-.88l3.66-2.4V3.55A.53.53 0 0 1 4.43 3a.52.52 0 0 1 .57.55v2.12l5-3.27 9.81 6.36a.51.51 0 0 1 .1.72\" class=\"cls-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol